<template>
  <div class="form-outline pa-3">
    <form-legend :field="field" />
    <!--<img :src="editorModel[key]" style="width: 100%" />-->
    <v-input
      :value="painted"
      :rules="field.required ? [() => painted || $t('field.required')] : []"
      :hint="field.field_options.description"
      persistent-hint
      v-bind="darkOrLightMode"
    >
      <div :ref="'sig-cell-' + key" class="d-flex flex-column full-width">
<!--        <legend-->
<!--          v-html="field.label + (field.required ? '*' : '')"-->
<!--          :class="'v-label theme&#45;&#45;' + mode"-->
<!--          :style="!initialState && !painted && 'color: rgb(211, 0, 12)'"-->
<!--        />-->
        <div class="full-width">
          <!-- Canvas width is calculated in signatureMixin -->
          <canvas
            :id="'sig-canvas-' + key"
            width="10"
            height="10"
            class="canvas"
            :class="borderOutline"
            style="touch-action: none"
            @mousedown="onMouseDown"
            @mousemove="onMouseMove"
            @mouseup="onMouseUp"
            @mouseleave="onMouseUp"
            @touchstart="onMouseDown"
            @touchmove="onMouseMove"
            @touchend="onMouseUp"
          >
            Unterschrift funktioniert nicht auf diesem Browser
          </canvas>
          <v-btn class="clear-btn" small icon @click="onClear"><v-icon @click="onClear">mdi-close</v-icon></v-btn>
        </div>
      </div>
      <!--      <template v-slot:message="{ message }">-->
      <!--        <legend v-html="message" />-->
      <!--      </template>-->
    </v-input>
  </div>
</template>

<script>
import signatureMixin from './signatureMixin';
import formsMixin from '../formsMixin';
import FormLegend from '@/modules/forms/FormLegend.vue';

export default {
  components: { FormLegend },
  props: {
    field: { type: Object, required: true },
    formModel: { type: Object, required: true },
    mediasModel: { type: Array, required: true },
    readonly: { type: Boolean, default: false },
    mode: { type: String, default: 'light' },
  },
  mixins: [signatureMixin, formsMixin],
  emits: ['formUpdated'],
  data() {
    return {
      editorModel: { [this.key]: '' },
    };
  },
  computed: {
    key() {
      return this.field.cid;
    },
  },
  watch: {
    formModel: {
      immediate: true,
      deep: true,
      handler(newValue) {
        const value = newValue[this.key] ? newValue[this.key] : '';
        if (this.editorModel[this.key] != value) {
          this.editorModel = { [this.key]: value };
        }
      },
    },
    editorModel: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.$emit('formUpdated', this.key, newValue[this.key]);
      },
    },
  },
  mounted() {
    this.onClear();
  },
};
</script>

<style scoped>
canvas {
  border: 1px solid rgba(99, 99, 99, 0.2);
  cursor: crosshair;
}
.theme--dark .canvas{
  background:#a0a0a0
}
.theme--light .canvas{
  background:#fff
}
.clear-btn {
  position: absolute;
  right: 0;
  top: 0px;
  width: 36px;
  height: 36px;
}
</style>